<template>
  <div class="layouts">
    <div class="nav_content">
      <div class="left" @click="back"><i class="el-icon-arrow-left"></i></div>
      <div class="title">{{ lang.cjwd }}</div>
    </div>
    <div class="faq">
      <div class="content-list">
        <div class="title">{{ lang.tip10 }}？</div>
        <div class="icons" @click="selectIndex(1)">
          <img src="../assets/images/minus.svg" v-if="showIndex == 1">
          <img src="../assets/images/add.svg" v-else>
        </div>
        <div :class="['info',showIndex == 1 ? 'info-all':'']">
          <p>{{lang.tip11}}</p>
        </div>
      </div>
      <div class="content-list">
        <div class="title">{{ lang.tip12 }}？</div>
        <div class="icons" @click="selectIndex(2)">
          <img src="../assets/images/minus.svg" v-if="showIndex == 2">
          <img src="../assets/images/add.svg" v-else>
        </div>
        <div :class="['info',showIndex == 2 ? 'info-all':'']">
          <p>{{lang.tip13}}</p>
        </div>
      </div>
      <div class="content-list">
        <div class="title">{{ lang.tip14 }}？</div>
        <div class="icons" @click="selectIndex(3)">
          <img src="../assets/images/minus.svg" v-if="showIndex == 3">
          <img src="../assets/images/add.svg" v-else>
        </div>
        <div :class="['info',showIndex == 3 ? 'info-all':'']">
          <p>{{ lang.tip15 }}：</p>
          <p>{{ lang.tip16 }}。</p>
          <p>{{ lang.tip17 }}。</p>
          <p> </p>
          <p>{{ lang.tip18 }}。</p>
        </div>
      </div>
      <div class="content-list">
        <div class="title">{{ lang.tip19 }}？</div>
        <div class="icons" @click="selectIndex(4)">
          <img src="../assets/images/minus.svg" v-if="showIndex == 4">
          <img src="../assets/images/add.svg" v-else>
        </div>
        <div :class="['info',showIndex == 4 ? 'info-all':'']">
          <p>{{ lang.tip20 }}</p>
        </div>
      </div>
    </div>
  </div>

</template>

<script type="text/javascript">
import store from "../store";
import { CONF,API_SERVER } from '@/assets/js/config'
import {mapState} from "vuex";

export default {
  data() {
    return {
      showIndex: 0,
      radio: CONF.LANG ,
    }
  },
  computed: {
    ...mapState(['lang'])
  },

  methods: {
    back(){
      this.$router.back()
    },
    selectIndex(index){
      if (this.showIndex == index){
        this.showIndex = 0
      }else {
        this.showIndex = index
      }
    },
  }
}
</script>


<style>
.layouts{
  background: #000;
  color: #fff;
  min-height: 100vh;
  padding: 0 20px;
}
.nav_content {
  padding:20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.nav_content .left{
  position: absolute;
  left: 20px;
  font-size: 20px;
  font-weight: 600;
}
.nav_content .title{
  font-size: 20px;
  font-weight: 600;
}

.faq .content-list {
  min-height: 50px;
  padding: 25px 20px;
  background: #1a1a1a;
  border-radius: 21px;
  margin-bottom: 16px;
  margin-top: 24px;
  position: relative;
}
.faq .content-list:before {
  content: "";
  display: inline-block;
  background: #c2e22a;
  border-radius: 5px;
  width: 5px;
  height: 24px;
  top: 20px;
  left: 0;
  position: absolute;
}
.faq .content-list .title {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 25px;
}
.faq .content-list .icons{
  position: absolute;
  width: 24px;
  height: 24px;
  top: 16px;
  right: 16px;
}
.faq .content-list .info {
  height: 34px;
  margin-top: 9px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff4d;
  line-height: 17px;
  overflow: hidden;
}
.faq .content-list .info-all {
  height: max-content;
}

</style>
